import { useTranslation } from 'react-i18next';
import type { BatchScopeState } from './batchScope';

interface BatchScopeNoticeProps {
  state: BatchScopeState | null;
  /** Open rows of the batch visible in the current list. */
  visibleCount: number;
}

/**
 * States what a batch approve/deny will really act on: every open proposal of
 * the batch across all accessible brands, which can exceed the visible rows.
 */
const BatchScopeNotice = ({ state, visibleCount }: BatchScopeNoticeProps) => {
  const { t } = useTranslation();

  if (!state || state.status === 'loading') {
    return (
      <p className='aq-batchscope aq-batchscope--loading' role='status'>
        {t('BatchScopeLoading')}
      </p>
    );
  }
  if (state.status === 'error') {
    return (
      <p className='aq-batchscope aq-batchscope--error' role='alert'>
        {t('BatchScopeLoadFailed')} {state.message}
      </p>
    );
  }

  const { items, brands } = state.scope;
  if (items.length === 0) {
    return <p className='aq-batchscope'>{t('BatchScopeNothingOpen')}</p>;
  }
  const hidden = Math.max(state.scope.hiddenCount, items.length - visibleCount);

  return (
    <div className='aq-batchscope'>
      <p className='aq-batchscope__count'>
        {t('BatchScopeCount', { n: items.length })}
      </p>
      {brands.length > 0 && (
        <p className='aq-batchscope__brands'>
          {t('BatchScopeBrands', { brands: brands.join(', ') })}
        </p>
      )}
      {hidden > 0 && (
        <p className='aq-batchscope__warning' role='alert'>
          {t('BatchScopeHiddenWarning', { n: hidden })}
        </p>
      )}
    </div>
  );
};

export default BatchScopeNotice;
